import React, { Component } from "react";

import { Navigate } from "react-router-dom";

import withRouter from "../withRouter/withRouter";
import ItemCard from "../ListItem/ItemCard";
import Pagination from "../Pagination/Pagination";

import "./Search.css";

class Search extends Component {
    constructor(props) {
        super(props);

        this.generate_query = this.generate_query.bind(this);

        this.request_data = this.request_data.bind(this);
        this.decode_URI = this.decode_URI.bind(this);
    }

    submitted_URI = null;

    componentDidMount() {
        let { connection } = this.props;
        connection
            .get_all_categories()
            .then((res) => {
                this.setState({ allCategories: res.data });
            })
            .catch(this.error_in_retrieving_data);
        this.decode_URI();
    }

    decode_URI() {
        this.submitted_URI = decodeURIComponent(
            this.props.router.location.search
        );
        let query = this.submitted_URI;
        query = this.parse_query(query) || {};
        let { page, count, sort, reverseSort } = query;

        query && delete query.page;
        query && delete query.count;
        query && delete query.sort;
        query && delete query.reverseSort;

        query.categories = JSON.parse(query.categories || "[]");

        this.searchText = query.search || "";

        typeof query.categories == "string" &&
            (query.categories = JSON.parse(query.categories || "[]"));
        this.setState(
            {
                filters: query,
                page: parseInt(page),
                count: parseInt(count) || 15,
                categories: query.categories,
                sort,
                reverseSort,
            },
            () => {
                this.request_data();
            }
        );
    }

    componentDidUpdate(_p) {
        this.submitted_URI !=
            decodeURIComponent(this.props.router.location.search) &&
            this.decode_URI();
    }

    generate_query() {
        let { page, count, sort, reverseSort, filters } = this.state;

        let query = filters || {};

        filters.search = this.searchText;
        console.log(filters,this.searchText);
        count && (query.count = count);
        page > -1 && (query.page = page);
        query.sort = sort;

        let queryKeys = query && Object.keys(query);
        return (
            "?" +
            queryKeys
                .filter((k) => {
                    return (
                        query[k] &&
                        (Array.isArray(query[k])
                            ? query[k].length > 0
                                ? k
                                : null
                            : k)
                    );
                })
                .map((k) => {
                    return (
                        k +
                        "=" +
                        (typeof query[k] === "string"
                            ? query[k]
                            : JSON.stringify(query[k]))
                    );
                })
                .join("&")
        );
    }

    parse_query(query) {
        let res = {};

        if (!query || typeof query != "string") return null;
        query = query.split("&");

        if (query.length < 1) return null;
        query[0] = query[0].replace("?", "");

        query.forEach((q) => {
            q = q.split("=");
            res[decodeURIComponent(q[0])] =
                q.length > 1 ? decodeURIComponent(q[1]) : "";
        });
        return res;
    }

    error_in_retrieving_data(err) {
        this.toast("  خطا", "خطا در دریافت اطلاعات : " + err, " danger");

        this.props.router.navigate("/");
    }

    request_data() {
        let { page, count, sort, reverseSort, filters } = this.state;
        filters.search = this.searchText;

        sort === "newest" && (sort = "add_time") && (reverseSort = "");
        sort === "oldest" && (sort = "add_time") && (reverseSort = true);
        sort === "highest_price" &&
            (sort = "retail_price") &&
            (reverseSort = "");
        sort === "lowest_price" &&
            (sort = "retail_price") &&
            (reverseSort = true);

        this.props.connection
            .get_filtered_data("items", filters, sort, count, reverseSort, page)
            .then((res) => {
                let { page, items, total } = res.data;
                this.setState({
                    page: parseInt(page),
                    items,
                    total: parseInt(total),
                });
            });
    }

    filters = [
        { name: "کالاهای موجود", value: "available" },
        { name: "کالاهای تخفیف دار", value: "has_discount" },
        { name: "کالاهای پیشنهادی", value: "is_suggestion" },
        { name: "کالاهای دارای فروش عمده", value: "has_wholesale" },
    ];

    sorts = [
        { name: "جدیدترین", value: "newest" },
        { name: "قدیمی ترین", value: "oldest" },
        { name: "گران ترین", value: "highest_price" },
        {
            name: "ارزان ترین",
            value: "lowest_price",
        },
    ];

    searchText = "";

    state = {
        navigate: null,
        items: null,
        allCategories: null,
        filters: { categories: [] },
        count: 15,
        page: 0,
        total: null,
        URI: false,
        showCategories: false,
    };
    render() {
        let {
            items,
            allCategories,
            filters,
            sort,
            count,
            page,
            total,
            navigate,
            categories,
            showCategories,
        } = this.state;
        total = parseInt(total) || 0;
        page = parseInt(page) || 0;
        count = parseInt(count) || 0;

        return (
            <div className='SearchComponent'>
                <div className='SearchContainer'>
                    <div className='searchTools'>
                        {navigate}
                        <div className='searchInput'>
                            <input
                                type='text'
                                name='search'
                                id='search'
                                defaultValue={this.searchText}
                                placeholder={
                                    "دنبال چیزی هستید؟  اینجا بنویسید."
                                }
                                onChange={(ev) => {
                                    this.searchText = ev.target.value;
                                }}
                            />
                        </div>

                        <div
                            className='showCats'
                            onClick={(ev) => {
                                this.setState({
                                    showCategories: !showCategories,
                                });
                            }}
                        >
                            <div className='caption text info'>
                                <i className='fa-solid fa-layer-group'></i>
                                نمایش دسته بندی ها
                            </div>
                            <input type='checkbox' checked={showCategories} />
                            {categories && categories.length > 0 && (
                                <div className='selectedCatsCount'>
                                    {`${categories.length} دسته بندی انتخاب شده است`}
                                </div>
                            )}
                        </div>

                        {showCategories &&
                            allCategories &&
                            allCategories.length > 0 && (
                                <div className='categories'>
                                    <div className='caption text info'>
                                        <i className='fa-solid fa-layer-group'></i>
                                        دسته بندی(های) مورد نظر را انتخاب کنید.
                                    </div>
                                    <div className='list'>
                                        {allCategories.map((cat) => {
                                            return (
                                                <div
                                                    className='category'
                                                    key={cat.name}
                                                >
                                                    <input
                                                        type='checkbox'
                                                        checked={categories.includes(
                                                            cat.name
                                                        )}
                                                        onChange={(ev) => {
                                                            let { categories } =
                                                                filters;
                                                            typeof categories ===
                                                                "string" &&
                                                                (categories =
                                                                    JSON.parse(
                                                                        categories ||
                                                                            "[]"
                                                                    ));
                                                            let i =
                                                                categories.findIndex(
                                                                    (c) => {
                                                                        return (
                                                                            cat.name ===
                                                                            c
                                                                        );
                                                                    }
                                                                );
                                                            ev.target.checked
                                                                ? i < 0 &&
                                                                  categories.push(
                                                                      cat.name
                                                                  )
                                                                : i > -1 &&
                                                                  categories.splice(
                                                                      i,
                                                                      1
                                                                  );
                                                            filters.categories =
                                                                categories;
                                                            this.setState({
                                                                filters,
                                                            });
                                                        }}
                                                    />
                                                    <div className='name'>
                                                        {cat.name}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                        <div className='filters'>
                            <div className='caption text info'>
                                <i className='fa-solid fa-filter'></i>
                                فیلتر :
                            </div>
                            {this.filters.map((filter) => {
                                return (
                                    <div className='filter' key={filter.value}>
                                        <input
                                            type='checkbox'
                                            checked={filters[filter.value]}
                                            onClick={(ev) => {
                                                ev.target.checked
                                                    ? (filters[
                                                          filter.value
                                                      ] = true)
                                                    : delete filters[
                                                          filter.value
                                                      ];
                                                this.setState({
                                                    filters,
                                                });
                                            }}
                                        />
                                        <div className='name'>
                                            {filter.name}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className='sort'>
                            <div className='caption text info'>
                                <i className='fa-solid fa-arrow-down-wide-short'></i>
                                ترتیب نمایش :
                            </div>
                            {this.sorts.map((s) => {
                                return (
                                    <div className='sort' key={s.name}>
                                        <button
                                            className={
                                                "btn " +
                                                (sort === s.value
                                                    ? "confirm"
                                                    : "info")
                                            }
                                            onClick={(ev) => {
                                                this.setState({
                                                    sort: s.value,
                                                });
                                            }}
                                        >
                                            {s.name}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>

                        <button
                            className='searchBtn btn confirm'
                            onClick={(ev) => {
                                this.setState({ page: 0 }, () => {
                                    this.props.router.navigate(
                                        "/search" + this.generate_query()
                                    );
                                });
                            }}
                        >
                            <i className='ri-search-2-line'></i>
                            جستجو
                        </button>
                    </div>

                    {items && items.length > 0 ? (
                        <div>
                            <div className='items'>
                                {items.map((item) => {
                                    return (
                                        <ItemCard item={item} key={item.id} />
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className='empty text danger'>
                            <i className='ri-close-circle-line text danger'></i>
                            متاسفانه هیچ کالایی با مشخصات درخواستی شما وجود
                            ندارد...
                        </div>
                    )}
                    {total && page != null && page != undefined && count ? (
                        <Pagination
                            count={count}
                            page={page}
                            total={total}
                            on_page_change={(p) => {
                                this.setState({ page: p }, () => {
                                    this.props.router.navigate(
                                        "/search" + this.generate_query()
                                    );
                                });
                            }}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

export default withRouter(Search);
